<template>
  <div>
    <b-dropdown-item v-if="!showIcon" @click="showForm = !showForm" active-class="active">Expedite Fee Calculator</b-dropdown-item>

    <b-modal id="expedite-fee-calculator-modal" title='Expedite Fee Calculator' v-model="showForm" :lazy="true"
      hide-footer
      size="l">

      <b-container fluid>
        <b-row class="py-3 px-0 mx-auto pb-0" style="max-width: 1200px">
          <b-col cols="10" class="px-0 mx-auto">

            <b-form-group label="Lead Time">
              <b-form-select :options="leadTimes" v-model="leadTime" @change="calculateLeadTimeResults">
                <template v-slot:first>
                  <b-form-select-option :value="null" disabled>-- Please select a lead time to start --</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>

            <label for="net-price">Net Price</label>
            <b-input-group prepend="$ ">
              <b-form-input
                id="net-price"
                type="number"
                v-model="netPrice"
                class="mx-auto"
                append="$"
                autofocus
                @change="calculateLeadTimeResults"></b-form-input>
            </b-input-group>

            <b-table v-if="leadTimeResults.length > 0 && netPrice > 0 && leadTime != null" small
                :items="leadTimeResults"
                :fields="leadTimeFields"
                :busy="loading"
                selectable
                striped
                select-mode="single"
                class="text-left mt-4">
              <template v-slot:table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(leadTime)="data">
                {{ data.value }}
              </template>

              <template v-slot:cell(netPrice)="data">
                {{ data.value | toCurrency }}
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-container>

      <b-button
        class="mt-3 float-right"
        style="width: 100px"
        block @click="$bvModal.hide('expedite-fee-calculator-modal')">Close</b-button>
    </b-modal>
  </div>
</template>

<script>
import VaWorksApi from '@/api/VaWorksApi'
import Vue from 'vue'

Vue.filter('toCurrency', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  })
  return formatter.format(value)
})

export default {
  props: [ 'showIcon' ],
  name: 'ExpediteFeeCalculator',
  data () {
    return {
      userFields: [ { key: 'userName', label: 'Name' }, 'email', { key: 'organizationName', label: 'Org' } ],
      organizations: [],
      feeOrganization: null,
      loading: true,
      orgUser: null,
      orgId: 1,
      users: [],
      searchUsers: [],
      searchText: '',
      leadTimes: [],
      leadTime: null,
      leadTimeResults: [],
      leadTimeFields: [ { key: 'leadTime', label: 'Lead Time' }, { key: 'netPrice', label: 'Net Price' } ],
      netPrice: 0,
      showForm: false,
      pagination: {
        pageSize: 10,
        page: 1,
        total: 0
      }
    }
  },
  created () {
    this.loadData(1)
    this.leadTimes = this.getOrgLeadTimes()
  },
  computed: {
    user () {
      return this.$store.state.auth.currentUser
    }
  },
  methods: {
    loadData (page) {
      var vm = this
      vm.loading = true
      VaWorksApi().get('Profile')
        .then((r) => {
          vm.userProfile = r.data
          vm.organizations = vm.userProfile.organizations.map((o) => {
            return {
              text: o.name,
              value: o
            }
          })
          vm.feeOrganization = vm.organizations[0].value
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          vm.loading = false
        })
    },
    loadContactsData (page) {
      var vm = this
      vm.loading = true
      VaWorksApi().get(`Organization/UsersSearch?page=${1}&pageSize=${10}&userSearchText=${vm.searchText}`)
        .then((r) => {
          vm.searchUsers = r.data.items
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          vm.loading = false
        })
    },
    organizationSelected (value) {
      var vm = this
      vm.loading = true
      vm.orgId = value.id
      VaWorksApi().get(`Organization/${value.id}/Users`)
        .then((r) => {
          vm.users = r.data.map((u) => {
            return {
              text: u.name,
              value: u
            }
          })
          vm.orgUser = vm.users.find((u) => {
            return u.value.id === vm.user.id
          }).value
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          vm.loading = false
        })
    },
    onRowSelected (item) {
      var vm = this
      VaWorksApi().get(`Organization/${item[0].organizationId}`)
        .then((r) => {
          vm.organizationSelected(r.data)
          vm.feeOrganization = r.data
          VaWorksApi().get(`User/${item[0].userId}`)
            .then((r) => {
              var user = {
                text: r.data.name,
                value: r.data
              }
              vm.orgUser = user.value
            })
        })
        .catch((e) => {
          console.log(e)
        })
    },
    getOrgLeadTimes () {
      var vm = this
      VaWorksApi().get(`Organization/${vm.orgId}/ExpediteFees`)
        .then((r) => {
          // Sort by fee: higher fees first
          // If fees are equal, sort days before weeks
          // Assumes that longer lead time means lower fee
          vm.expediteFees = r.data.sort((lt1, lt2) => {
            if (lt1.fee !== lt2.fee) {
              if (lt1.fee > lt2.fee) return -1
              if (lt1.fee < lt2.fee) return 1
            } else {
              if (lt1.leadTime.includes('Day') && lt2.leadTime.includes('Week')) return -1
              if (lt1.leadTime.includes('Week') && lt2.leadTime.includes('Day')) return 1
            }
          })

          vm.leadTimes = vm.expediteFees.map((lt) => {
            return {
              text: lt.leadTime,
              value: lt
            }
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },
    calculateLeadTimeResults () {
      let vm = this
      if (vm.leadTime != null && vm.netPrice > 0) {
        let netPriceFee = vm.leadTime.fee * vm.netPrice

        if (netPriceFee < vm.leadTime.min) {
          netPriceFee = vm.leadTime.min
        } else if (netPriceFee > vm.leadTime.max) {
          netPriceFee = vm.leadTime.max
        }

        let leadtime1 = ''
        let oneLeadTime = null
        let netPriceFee1 = 0
        let leadtime2 = ''
        let twoLeadTime = null
        let netPriceFee2 = 0

        if (vm.leadTime.leadTime === 'Next Day') {
          leadtime1 = '2 Days'
        } else if (vm.leadTime.leadTime !== '9 Days') {
          leadtime1 = (parseInt(vm.leadTime.leadTime.substring(0, vm.leadTime.leadTime.indexOf(' '))) + 1) + ' Days'
        } else {
          leadtime1 = vm.leadTime.leadTime
        }

        oneLeadTime = vm.leadTimes.find(lt => {
          return lt.value.leadTime === leadtime1
        }).value

        netPriceFee1 = oneLeadTime.fee * vm.netPrice

        if (netPriceFee1 < oneLeadTime.min) {
          netPriceFee1 = oneLeadTime.min
        } else if (netPriceFee1 > oneLeadTime.max) {
          netPriceFee1 = oneLeadTime.max
        }

        if (leadtime1 !== '9 Days') {
          leadtime2 = (parseInt(leadtime1.substring(0, leadtime1.indexOf(' '))) + 1) + ' Days'
          twoLeadTime = vm.leadTimes.find(lt => {
            return lt.value.leadTime === leadtime2
          }).value

          netPriceFee2 = twoLeadTime.fee * vm.netPrice

          if (netPriceFee2 < twoLeadTime.min) {
            netPriceFee2 = twoLeadTime.min
          } else if (netPriceFee2 > twoLeadTime.max) {
            netPriceFee2 = twoLeadTime.max
          }
        }

        vm.leadTimeResults = [
          {
            leadTime: vm.leadTime.leadTime,
            fee: netPriceFee,
            netPrice: vm.roundDollar(parseFloat(vm.netPrice) + netPriceFee)
          },
          {
            leadTime: vm.leadTime.leadTime === '9 Days' ? '' : leadtime1,
            fee: vm.leadTime.leadTime === '9 Days' ? 0 : netPriceFee1,
            netPrice: vm.leadTime.leadTime === '9 Days' ? vm.roundDollar(parseFloat(vm.netPrice)) : vm.roundDollar(parseFloat(vm.netPrice) + netPriceFee1)
          },
          {
            leadTime: leadtime2,
            fee: netPriceFee2,
            netPrice: netPriceFee2 === 0 ? vm.roundDollar(parseFloat(vm.netPrice)) : vm.roundDollar(parseFloat(vm.netPrice) + netPriceFee2)
          }
        ]
      }
    },
    roundDollar (price) {
      return Math.ceil(price * 4) / 4
    }
  },
  watch: {
    searchText (value) {
      this.loadContactsData(1)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/app/ExpediteFeeCalculator.vue